import { render, staticRenderFns } from "./SvgCircle.vue?vue&type=template&id=47bbb68f&"
import script from "./SvgCircle.vue?vue&type=script&lang=js&"
export * from "./SvgCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports